<template lang="pug">
  #properties.center-panel.md-scrollbar.md-theme-default
    module-menu
    md-content.md-layout-row.md-gutter.md-elevation-1(md-theme="white")
      .md-flex(md-theme="white")
        md-table(md-theme="white")
          md-table-row(v-if="!Object.keys(properties).length")
            md-table-cell.load
              span.md-layout-row.md-gutter
                span.md-flex.name "У этой сущности не созданно свойств"
          md-table-row(v-if="Object.keys(properties).length" v-for="property in properties" v-bind:key="property.id" v-bind:class="($route.params.entity_prop_code && $route.params.entity_prop_code == property.code) ? 'property-row hovered' : 'property-row'")
            md-table-cell.left
              router-link.small.md-primary(v-bind:to="{ name: 'EntityProperty', params: {code: $route.params.code, entity_code: $route.params.entity_code, entity_prop_code: property.code}, query: $route.query }")
                span.md-layout-row.md-gutter
                  span.md-flex.name {{property.name + ' (' + property.code + ')'}}
            md-table-cell.right
              .actions-wrapper
                .actions
                  md-button.md-icon-button.md-dense.small(:to="{ name: 'EntityPropertyValues', params: {code: $route.params.code, entity_code: $route.params.entity_code, entity_prop_code: property.code}}" v-if="(['checkbox', 'radio', 'select'].indexOf(property.field_type) + 1)"): md-icon playlist_add
                  md-button.md-icon-button.md-dense.small(@click="showRemoveDialog(property.id)"): md-icon delete
          md-button.md-dense(v-bind:to="{ name: 'NewEntityProperty', params: { code: $route.params.code}}") Добавить свойство #[md-icon add]
      md-dialog-confirm(:md-active.sync="removeDialog" md-title="Удалить выбранное свойство?" md-content="Внимание! Действие необратимо!" md-confirm-text="Удалить" md-cancel-text="Отмена" @md-cancel="removeDialog = false" @md-confirm="removeProperty()")
</template>

<script>
  import ModuleMenu from './menu.vue';

  export default {
    data() {
      return {
        removeDialog: false,
        removePropertyId: '',
      }
    },
    watch: {
      'entities'() {
        this.getModuleEntitiesProperties();
      }
    },
    components: {
      ModuleMenu
    },
    computed: {
      properties() {
        return this.$store.state.module.entity_properties;
      },
      entities() {
        return this.$store.state.module.entities;
      }
    },
    created() {
      this.getModuleEntitiesProperties();
    },
    methods: {
      showRemoveDialog(propCode) {
        this.removeDialog = true;
        this.removePropertyId = propCode;
      },
      removeProperty() {
        this.$store.dispatch('module/removeModuleEntitiesProperty', this.removePropertyId);
      },
      getModuleEntitiesProperties() {
        this.$store.dispatch('module/getModuleEntitiesProperties');
      }
    }
  }
</script>
<style scoped lang="sass">
  #properties
    .property-row.hovered
      .md-table-cell
        background-color: var(--md-theme-default-highlight-on-background, rgba(0, 0, 0, 0.08))
    .actions-wrapper
      text-align: right
</style>



// WEBPACK FOOTER //
// Entity.vue?40de8666